<template>
<v-app class="grey lighten-4">

    <Navbar v-if="this.$store.getters.showNavbar" />
    <v-content class="mx-4 mb-4">
        <router-view></router-view>
        <v-footer app>
            <v-spacer></v-spacer>
 
                <div class="caption grey--text ">Ballerup Rideklub | FoldPlan v.{{this.version}} | &copy; {{ new Date().getFullYear() }} - Tid: {{this.clock}}</div>
 
        </v-footer>
    </v-content>
</v-app>
</template>

<script>
import Navbar from '@/components/Navbar';
import firebase from 'firebase/app';
import format from 'date-fns/format';
//import axios from "axios";
export default {
    name: 'App',
    components: {
        Navbar
    },
    data() {
        return {
            timeSet: false,
            serverTime: "",
            timerInterval: null,
            timePassed: 0,
            clock: 0,
            hour:0,
        }
    },
    methods: {
        setAuthUser: function () {
            this.$store.dispatch('setAuthUser').then(() => {
                //console.log('firebase.auth().currentUser ' + firebase.auth().currentUser)
                if (firebase.auth().currentUser === null || firebase.auth().currentUser == null || typeof firebase.auth().currentUser === 'undefined') {
                    //console.log('App.vue cant setProfile')
                } else {
                    //console.log('App.vue setProfile')
                    this.$store.dispatch('setProfile', {
                        vm: this
                    })
                }
            })

        },
        loadResources: function () {
            this.$store.dispatch('loadResources', {
                vm: this
            })
        },
        loadUsers: function () {
            this.$store.dispatch('loadUsers', {
                vm: this
            })
        },
        loadHorses: function () {
            this.$store.dispatch('loadHorses', {
                vm: this
            })
        },

        setResid: function () {
            this.$store.dispatch('setResid', 'GAocPGFqUBPSDL4dAo5d')
        },
        loadConfig: function () {
            this.$store.dispatch('loadConfig', {
                vm: this
            })

        },
        loadBookings: function () {
            this.$store.dispatch('loadBookings', {
                vm: this
            })
        },
        //getMaxDate() {
            //if (this.$store.getters.hour >=21){
                //console.log("#1#", this.$store.getters.hour);
            //    return this.date.setDate(this.date.getDate() + 2)                
            //}                
            //else{
                //console.log("#2#", this.$store.getters.hour);
            //    return this.date.setDate(this.date.getDate() + 1)
            //}


        //},    
        startTimer() {
            this.timerInterval = setInterval(() => (this.timePassed += 1), 1000);
        },   
        addDays(date, days) {
            var result = new Date(date);
            result.setDate(result.getDate() + days);
            return result;
        },             
        setServerTime(){
            fetch ("https://worldtimeapi.org/api/timezone/Europe/Copenhagen").then(response => {   
                
                return response.json();
            }).then((data) => {
                console.log("#serverTime updated#", data.datetime);
 
                this.serverTime = data.datetime;
                this.timePassed = 0;
            }).catch(function(e) {
                console.error(e.message);
            });            
        }
    },



    mounted(){
        
        
        this.startTimer();       
    },

    computed: {
        accountActive() {
            return this.$store.getters.profile.active
        },
        version() {
            return this.$store.getters.config.version
        },
        date() {
            return new Date()
        },        
    },
    watch: {
        accountActive: function () {
            if (this.$store.getters.profile !== null && this.$store.getters.profile != null && typeof this.$store.getters.profile !== 'undefined') {
                if (this.$store.getters.profile.active) {
                    console.log('accountActive, OK')
                } else {
                    this.$store.dispatch('setShowNavbar', false)
                    this.$router.push({
                        name: 'accountdisabled'
                    })
                    console.log('accountActive, not OK')
                }
            }

        },
        
        timePassed: function () {
            var tmp; 
            var tmpDate; 
            
            //console.log('#timePassed - this.serverTime#', this.serverTime);
            
            if (this.serverTime === "" && this.timePassed == 5){
                this.setServerTime();
                console.log('# timePassed: serverTime not ready ');
            }

            else 
            {
                if(!this.timeSet){
                    tmp = this.serverTime.split('+');
                    tmpDate = Date(tmp[0]);                
                    this.serverTime = tmpDate;

                    this.clock =  format(this.serverTime , "H:mm:ss");
                    this.hour = format(this.serverTime, "H");
                    

                    this.timeSet = true;
                }
                else{
                    //console.log('# this.timePassed : ', this.timePassed);
                    if (this.timePassed == 15){
                        //console.log('# timePassed - time to update:  ', this.serverTime);
                        this.setServerTime();
                        //console.log('# timePassed - updated:  ', this.serverTime);
                        
                    }
                    //console.log('#timePassed - this.serverTime#', this.serverTime);
                    var dt = new Date(this.serverTime)
                    //console.log('# dt.getSeconds():  ', dt.getSeconds());
                    dt.setSeconds( dt.getSeconds() + this.timePassed );
                    //console.log('# dt.getSeconds():  ', dt.getSeconds());
                    this.clock =  format(dt, "H:mm:ss");
                    this.hour = format(dt, "H");
                    this.minute = format(dt, "mm");
                    this.$store.dispatch('setClock', this.clock);

                    //console.log('# hour : ', this.hour);
                    //console.log('# minute : ', this.minute);
                    
                    if(this.hour >= 21  ){
                        
                        this.$store.dispatch('setMaxDate', format(this.addDays(this.serverTime, 2), 'YYYY-MM-DD'));

                        }
                    else
                        this.$store.dispatch('setMaxDate', format(this.addDays(this.serverTime, 1), 'YYYY-MM-DD'));
                   
                }
            }

        }


    },

    created() {

        // when the app is created run the set user method
        // this uses Vuex to check if a user is signed in
        // check out mutations in the store.js file
        this.setServerTime();
        //console.log("#1#", new Date().getHours(), new Date().getMinutes(), new Date().getSeconds() );
        this.loadResources();
       //console.log("#2#", new Date().getHours(), new Date().getMinutes(), new Date().getSeconds() );

        this.setAuthUser();
        //console.log("#3#", new Date().getHours(), new Date().getMinutes(), new Date().getSeconds() );        
        this.loadUsers();
        //console.log("#4#", new Date().getHours(), new Date().getMinutes(), new Date().getSeconds() );        
        this.loadHorses();
        //console.log("#5#", new Date().getHours(), new Date().getMinutes(), new Date().getSeconds() );
        this.loadBookings();
        //console.log("#6#", new Date().getHours(), new Date().getMinutes(), new Date().getSeconds() );
        this.setResid();
        //console.log("#7#", new Date().getHours(), new Date().getMinutes(), new Date().getSeconds() );        
        this.loadConfig();
        //console.log("#8#", new Date().getHours(), new Date().getMinutes(), new Date().getSeconds() );
        //this.reloadNewVersion();
        

        if (this.$store.getters.version != this.$store.getters.versionCode){
            console.log("versionCode", this.$store.getters.versionCode);
            console.log("versionStore", this.$store.getters.version);
            this.$router.push({
            name: 'newversion'
            });
        }
        else{
            this.$router.push({
                name: 'loading'
            });
        }


        this.$store.dispatch('setHour', new Date().getHours());
        //this.$store.dispatch('setMaxDate', format(this.getMaxDate(), 'YYYY-MM-DD'));
        this.$store.dispatch('setDateSelected', format(Date.now(), 'YYYY-MM-DD'));
        this.$store.dispatch('setDateCurrent', format(Date.now(), 'YYYY-MM-DD'));

    }
}
</script>

<style>
 
</style>
